const en = {
  title: 'Action confirmation',
  listIsFull: 'Persona list is full',
  savedPersonasTxt: 'Saved Personas',
  personaLimit:
    'Your persona list is full. You can free up some space by deleting one of your',
};

export default en;
